(function () {
  if (window.lppUpsellClickInstalled) return;
  window.lppUpsellClickInstalled = true;

  let busy = false;

  window.addEventListener('click', async function (event) {
    const button = event.target.closest?.('.lpp-upsell-add');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (busy || button.disabled) return;

    const french = document.documentElement.lang.startsWith('fr');
    const variantId = button.dataset.variantId;
    const drawer = button.closest('cart-drawer');
    const root = window.Shopify?.routes?.root || '/';

    if (!variantId || !drawer) {
      alert(french
        ? 'Bouton incomplet ou tiroir introuvable.'
        : 'Incomplete button or cart drawer not found.');
      return;
    }

    busy = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    let added = false;

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1
          }]
        })
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description || result.message ||
          (french ? 'Impossible d’ajouter cet article.'
                  : 'Unable to add this item.')
        );
      }

      added = true;

      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('sections', 'cart-drawer');

      const sectionResponse = await fetch(sectionUrl.toString(), {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });

      if (!sectionResponse.ok) {
        throw new Error('Section HTTP ' + sectionResponse.status);
      }

      const sections = await sectionResponse.json();
      const html = sections['cart-drawer'];

      if (!html) {
        throw new Error(french
          ? 'Section du panier vide.'
          : 'Empty cart section.');
      }

      const parsed = new DOMParser().parseFromString(html, 'text/html');

      if (!parsed.querySelector('#CartDrawer')) {
        throw new Error(french
          ? 'Contenu du tiroir introuvable.'
          : 'Cart drawer content not found.');
      }

      drawer.classList.remove('is-empty');
      drawer.renderContents({
        id: result.items?.[0]?.id || Number(variantId),
        sections: sections
      });
    } catch (error) {
      console.error('LPP upsell:', error);

      alert(added
        ? (french
            ? 'Article ajouté, mais le tiroir ne s’est pas actualisé. Recharge la page. '
            : 'Item added, but the drawer did not refresh. Reload the page. ')
          + error.message
        : error.message);
    } finally {
      busy = false;

      if (button.isConnected) {
        button.removeAttribute('aria-busy');
        button.disabled = added;
      }
    }
  }, true);
})();